import * as z from "zod";

const SSH_PUBLIC_KEY_PATTERN =
  /^(?:ssh-(?:rsa|ed25519)|ecdsa-sha2-nistp(?:256|384|521))[ \t]+\S+(?:[ \t]+[^\r\n]*)?$/;

export const sshPublicKeySchema = z
  .string()
  .trim()
  .min(1, "Enter an SSH public key")
  .max(2048, "SSH public keys cannot exceed 2,048 characters")
  .regex(
    SSH_PUBLIC_KEY_PATTERN,
    "Enter a valid RSA, ECDSA, or ED25519 SSH public key",
  );

export const sshKeySchema = z.object({
  name: z.string().trim().min(1, "Enter a name").max(100),
  publicKey: sshPublicKeySchema,
});

export const addFileExchangeSftpPublicKey = {
  name: "addFileExchangeSftpPublicKey" as const,
  input: sshKeySchema,
  output: z.object({
    key: z.object({ name: z.string(), fingerprint: z.string() }),
  }),
};
